<template>
    <div v-if="episode" class="w-full">
        <!-- Episode Header -->
        <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 rounded-lg overflow-hidden mb-8 p-6 md:p-8">
            <div class="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                <!-- Episode Image -->
                <div class="md:col-span-4">
                    <img :src="episode.image ?? episode.podcast.image" :alt="episode.title"
                        class="rounded-lg w-full shadow-lg object-cover" />
                </div>

                <!-- Episode Info -->
                <div class="md:col-span-8 space-y-4">
                    <!-- Title -->
                    <h1 class="text-white font-bold text-3xl md:text-4xl">{{ episode.title }}</h1>

                    <!-- Podcast Link -->
                    <div class="space-y-2">
                        <h3 class="text-nomad-300 text-sm uppercase tracking-wide font-medium">Podcast</h3>
                        <Link :href="'/podcast/' + episode.podcast_id"
                            class="text-lg text-nomad-accent hover:text-nomad-accent/80 font-semibold transition-colors">
                            {{ episode.podcast.title }}
                        </Link>
                    </div>

                    <!-- Host -->
                    <div class="space-y-2">
                        <h3 class="text-nomad-300 text-sm uppercase tracking-wide font-medium">Host</h3>
                        <p class="text-nomad-200 font-semibold">{{ episode.podcast.host }}</p>
                    </div>

                    <!-- Play Button & Metadata -->
                    <div class="flex items-center gap-4 pt-2">
                        <button @click="prepareCurrent({ id: episode.id, type: 'EPISODE', title: episode.title || episode.name })"
                            class="flex items-center gap-2 px-6 py-3 bg-nomad-accent hover:bg-nomad-accent/80 text-nomad-900 font-semibold rounded-lg transition-all hover:scale-105">
                            <span class="icon-play text-lg"></span>
                            <span>Play Episode</span>
                        </button>
                        <div class="flex items-center gap-4">
                            <div v-if="episode.ordering" class="space-y-1">
                                <p class="text-nomad-300 text-xs uppercase tracking-wide font-medium">Episode</p>
                                <p class="text-nomad-200 font-semibold">#{{ episode.ordering }}</p>
                            </div>
                            <div v-if="episode.source" class="space-y-1">
                                <p class="text-nomad-300 text-xs uppercase tracking-wide font-medium">Duration</p>
                                <p class="text-nomad-200 font-semibold">{{ episode.source[0].length }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Episode Description -->
        <div class="space-y-4">
            <h2 class="text-2xl font-bold text-white">Description</h2>
            <div class="bg-nomad-800 rounded-lg p-6 text-nomad-200 font-light leading-relaxed"
                v-html="episode.description"></div>
        </div>
    </div>
</template>
<script setup>
defineProps({ episode: Object });
</script>
<script>
import { Link, usePage } from "@inertiajs/vue3";
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import EpisodeCard from "@/components/EpisodeCard.vue";
export default {
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
        formatDuration(seconds) {
            if (!seconds) return '';
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            if (hours > 0) {
                return `${hours}h ${minutes}m`;
            }
            return `${minutes}m`;
        }
    },
    beforeMount() {
        document.title = this.episode.title
    },
    components: {
        Link,
        EpisodeCard,
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    }
};
</script>
